var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSpeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.22392e-06C3.136 1.89952e-06 5.48316e-07 3.136 1.22392e-06 7C1.89952e-06 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 5.48316e-07 7 1.22392e-06ZM9.8 7C9.604 7 9.429 6.923 9.303 6.797L7.7 5.187L7.7 10.5C7.7 10.885 7.385 11.2 7 11.2C6.615 11.2 6.3 10.885 6.3 10.5L6.3 5.187L4.697 6.797C4.571 6.923 4.396 7 4.2 7C3.815 7 3.5 6.685 3.5 6.3C3.5 6.104 3.577 5.929 3.703 5.803L6.503 3.003C6.629 2.877 6.804 2.8 7 2.8C7.196 2.8 7.371 2.877 7.497 3.003L10.297 5.803C10.423 5.929 10.5 6.104 10.5 6.3C10.5 6.685 10.185 7 9.8 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSpeedIcon);
export default __webpack_public_path__ + "static/media/upload_speed_icon.1c3262af8aa0861279aefbc92f2df7e2.svg";
export { ForwardRef as ReactComponent };